import React, { useState } from "react";
import { PageHeader, Tabs } from "stories/Admin";
import AiQuranTab from "./AiQuranTab";
import QuranTextAdminTab from "./QuranTextAdminTab";

type QuranTab = "ai" | "text";

const QuranPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<QuranTab>("text");

  // Each tab renders the header itself so it can put its own actions there.
  const top = (actions?: React.ReactNode) => (
    <>
      <PageHeader
        title="Koranen"
        subtitle={
          activeTab === "text"
            ? "Koran-tekst fra leskoranen.no, oversettelser, lyd og fonter."
            : "AI-generert vers som vises på Min side i appen."
        }
        actions={actions}
      />
      <Tabs
        label="Koranen"
        value={activeTab}
        onChange={setActiveTab}
        tabs={[
          { value: "text", label: "Koran-tekst" },
          { value: "ai", label: "AI: dagens vers" },
        ]}
      />
    </>
  );

  return activeTab === "text" ? (
    <QuranTextAdminTab top={top} />
  ) : (
    <AiQuranTab top={top} />
  );
};

export default QuranPage;
